import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import ScrollAnimation from 'react-animate-on-scroll';

class CourseHomepage extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="pricing-area pd-top-90 pd-bottom-90" style={{backgroundImage: 'url('+publicUrl+'assets/img/testimonial/bg.png)', backgroundSize: 'cover', backgroundPosition: 'center'}}>
			  <div className="container">
			  	<div className="row justify-content-center">
			      <div className="col-xl-6 col-lg-7 col-md-11">
			        <div className="section-title text-center">
						<ScrollAnimation animateIn="fadeInDown">
							<h6 className="sub-title double-line">Our Courses</h6>
							<h2 className="title">Choose Your Future </h2>
						</ScrollAnimation>
			        </div>
			      </div>
			    </div><br />
			    <div className="row justify-content-center">
			      <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						
					 	
						{/* <p className='font-sizeCourse'>The AIME (Associate Member of the Institution of Engineers) course provided by MIET is recognised by all State Govts, Central Govt, AICTE, UPSC, etc., that is equivalent to any engineering degree.</p> */}
			            <div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-one">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-one" aria-expanded="true" aria-controls="f-one">
												<center>
													<img src={publicUrl+"assets/img/website/Craft-courses.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">Skill Development Courses</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-one" className="collapse" aria-labelledby="ff-one" data-parent="#accordion">
										<div className="card-body">
											<Link to="/ncvt-course">
											<div class="box-1">
												<div class="btn btn-one">
													<span>NCVT Courses</span>
												</div>
											</div>
											</Link>
											<Link to="/industrial-school-courses">
											<div class="box-1">
												<div class="btn btn-one">
													<span>Industrial School Courses</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			            {/* <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Diploma-courses.png"} alt="img"/>
						</center> */}
					 	{/* <h5 className='courHeading'><Link to="/">Diploma Courses</Link></h5> */}
						{/* <p className='font-sizeCourse'>DIPLOMA Courses provided by MIET gives added value to your career and increases the chances of getting hired faster.</p> */}
			            
			            {/* <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-two">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-two" aria-expanded="true" aria-controls="f-two">
												<center>
													<img src={publicUrl+"assets/img/website/Catering-&-Hotel-management-courses.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">Hotel Management & Catering Technology </Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-two" className="collapse" aria-labelledby="ff-two" data-parent="#accordion">
										<div className="card-body">
											<Link to="/hotel-management-courses-in-chennai">
											<div class="box-1">
												<div class="btn btn-one">
													<span>Courses <br/> (Degree/Diploma/Craft)</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/NCVT-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">NCVT Courses</Link></h5>
						<p className='font-sizeCourse'>NCVT (National Council for Vocational Training) course approved by the Govt of India, Ministry of Labor & Director General of Employment and Training, provided by MIET gives immense skills to attain knowledge in crafts & skills.</p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-three">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-three" aria-expanded="true" aria-controls="f-three">
												<center>
													<img src={publicUrl+"assets/img/website/NRA-CET.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">Entrance Exam Courses</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-three" className="collapse" aria-labelledby="ff-three" data-parent="#accordion">
										<div className="card-body">
											<Link to="/neet-courses-in-chennai">
											<div class="box-1">
												<div class="btn btn-one">
													<span>NEET</span>
												</div>
											</div>
											</Link>
											<Link to="/jee-courses-in-chennai">
											<div class="box-1">
												<div class="btn btn-one">
													<span>JEE</span>
												</div>
											</div>
											</Link>
											<Link to="/nata-courses-in-chennai">
											<div class="box-1">
												<div class="btn btn-one">
													<span>NATA</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Industrial-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Industrial Courses</Link></h5>
						<p className='font-sizeCourse'>MIET provides First-hand technical and practical knowledge to students to increase their skill set and value in the industrial sector.</p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-four">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-four" aria-expanded="true" aria-controls="f-four">
												<center>
													<img src={publicUrl+"assets/img/website/AMIE-courses.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">Arts & Science</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-four" className="collapse" aria-labelledby="ff-four" data-parent="#accordion">
										<div className="card-body">
											<Link to="/tmg-college-of-arts-and-science">
											<div class="box-1">
												<div class="btn btn-one">
													<span> TMG College of Arts & Science</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Catering-&-Hotel-management-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Catering & Hotel Management Courses</Link></h5>
						<p className='font-sizeCourse' style={{minHeight: '180px'}}>Learn food service, accommodation, catering and strong management skills provided by MIET that can enhance your career in a growing field.</p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-five">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-five" aria-expanded="true" aria-controls="f-five">
												<center>
													<img src={publicUrl+"assets/img/website/NCVT-courses.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">Distance Education Courses</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-five" className="collapse" aria-labelledby="ff-five" data-parent="#accordion">
										<div className="card-body">
											<Link to="/university-of-madras">
											<div class="box-1">
												<div class="btn btn-one">
													<span> University of Madras</span>
												</div>
											</div>
											</Link>
											<Link to="/bharathidasan-university">
											<div class="box-1">
												<div class="btn btn-one">
													<span>Bharathidasan University</span>
												</div>
											</div>
											</Link>
											<Link to="/tamilnadu-open-university">
											<div class="box-1">
												<div class="btn btn-one">
													<span> Tamil Nadu Open University</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Craft-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Craft Courses</Link></h5>
						<p className='font-sizeCourse'>MIET offers its students strong crafting skills that are effective & efficient in their career and to practice in real life. </p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-six">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-six" aria-expanded="true" aria-controls="f-six">
												<center>
													<img src={publicUrl+"assets/img/website/Date-science-&-AI.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">Information Technology Courses </Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-six" className="collapse" aria-labelledby="ff-six" data-parent="#accordion">
										<div className="card-body">
											<Link to="/data-science-and-artificial-intelligence-courses">
											<div class="box-1">
												<div class="btn btn-one">
													<span>Data Science & AI</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Craft-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Craft Courses</Link></h5>
						<p className='font-sizeCourse'>MIET offers its students strong crafting skills that are effective & efficient in their career and to practice in real life. </p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-seven">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-seven" aria-expanded="true" aria-controls="f-seven">
												<center>
													<img src={publicUrl+"assets/img/website/School-Course-Icons.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">School Courses </Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-seven" className="collapse" aria-labelledby="ff-seven" data-parent="#accordion">
										<div className="card-body">
											<Link to="/school-courses">
											<div class="box-1">
												<div class="btn btn-one">
													<span>Classes IX, X, XI, XII</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Craft-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Craft Courses</Link></h5>
						<p className='font-sizeCourse'>MIET offers its students strong crafting skills that are effective & efficient in their career and to practice in real life. </p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-eight">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-eight" aria-expanded="true" aria-controls="f-eight">
												<center>
													<img src={publicUrl+"assets/img/website/Eligibility-Test.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">Eligibility Tests<br/>(SSC, RRB, IBPS)</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-eight" className="collapse" aria-labelledby="ff-eight" data-parent="#accordion">
										<div className="card-body">
											<Link to="/nra-cet-courses-in-chennai">
											<div class="box-1">
												<div class="btn btn-one">
													<span>NRA CET</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Craft-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Craft Courses</Link></h5>
						<p className='font-sizeCourse'>MIET offers its students strong crafting skills that are effective & efficient in their career and to practice in real life. </p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-eight1">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-eight1" aria-expanded="true" aria-controls="f-eight1">
												<center>
													<img src={publicUrl+"assets/img/website/GATE.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">GATE</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-eight1" className="collapse" aria-labelledby="ff-eight1" data-parent="#accordion">
										<div className="card-body">
											<Link to="/gate-coaching-centre-in-chennai">
											<div class="box-1">
												<div class="btn btn-one">
													<span>GATE</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Craft-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Craft Courses</Link></h5>
						<p className='font-sizeCourse'>MIET offers its students strong crafting skills that are effective & efficient in their career and to practice in real life. </p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-eight2">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-eight2" aria-expanded="true" aria-controls="f-eight2">
												<center>
													<img src={publicUrl+"assets/img/website/NET.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">NET</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-eight2" className="collapse" aria-labelledby="ff-eight2" data-parent="#accordion">
										<div className="card-body">
											<Link to="/ugc-net-coaching-centre-in-chennai">
											<div class="box-1">
												<div class="btn btn-one">
													<span>NET</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Craft-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Craft Courses</Link></h5>
						<p className='font-sizeCourse'>MIET offers its students strong crafting skills that are effective & efficient in their career and to practice in real life. </p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-eight3">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-eight3" aria-expanded="true" aria-controls="f-eight3">
												<center>
													<img src={publicUrl+"assets/img/website/SLET.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">SLET</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-eight3" className="collapse" aria-labelledby="ff-eight3" data-parent="#accordion">
										<div className="card-body">
											<Link to="/slet-coaching-centre-in-chennai">
											<div class="box-1">
												<div class="btn btn-one">
													<span>SLET</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Craft-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Craft Courses</Link></h5>
						<p className='font-sizeCourse'>MIET offers its students strong crafting skills that are effective & efficient in their career and to practice in real life. </p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-eight4">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-eight4" aria-expanded="true" aria-controls="f-eight4">
												<center>
													<img src={publicUrl+"assets/img/website/IES.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">IES</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-eight4" className="collapse" aria-labelledby="ff-eight4" data-parent="#accordion">
										<div className="card-body">
											<Link to="/ies-training-institute-chennai">
											<div class="box-1">
												<div class="btn btn-one">
													<span>IES</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Craft-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Craft Courses</Link></h5>
						<p className='font-sizeCourse'>MIET offers its students strong crafting skills that are effective & efficient in their career and to practice in real life. </p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-eight5">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-eight5" aria-expanded="true" aria-controls="f-eight5">
												<center>
													<img src={publicUrl+"assets/img/website/Engineering-&-Architecture-Guidance-Programme.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">Engineering & Architecture Guidance Program</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-eight5" className="collapse" aria-labelledby="ff-eight5" data-parent="#accordion">
										<div className="card-body">
											<Link to="/engineering-and-architecture-guidance-program">
											<div class="box-1">
												<div class="btn btn-one">
													<span>Engineering & Architecture Guidance Program</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>

				  <div className="col-lg-4 col-md-6">
			        <div className="single-pricing-inner-wrap">
			          <div className="single-pricing-inner">
						{/* <center>
					  		<img src={publicUrl+"assets/img/website/Craft-courses.png"} alt="img"/>
						</center>
					 	<h5 className='courHeading'><Link to="/">Craft Courses</Link></h5>
						<p className='font-sizeCourse'>MIET offers its students strong crafting skills that are effective & efficient in their career and to practice in real life. </p>
			            
			            <Link className="btn btn-base btn-radius w-100 clrWhite" to="#">GET STARTED</Link> */}
						<div className="col-lg-12">
							<div id="accordion" className="accordion-area">
								<div className="card single-faq-inner">
									<div className="card-header" id="ff-eight6">
										<h5 className="mb-0">
											<button className="btn-link" data-toggle="collapse" data-target="#f-eight6" aria-expanded="true" aria-controls="f-eight6">
												<center>
													<img src={publicUrl+"assets/img/website/tnpsc.png"} alt="img"/>
												</center>
												<h5 className='courHeading'><Link to="/">TNPSC & TRB</Link></h5>
												<center>
													<i className="fa fa-chevron-circle-down" />
												</center>
											</button>
										</h5>
									</div>
									<div id="f-eight6" className="collapse" aria-labelledby="ff-eight6" data-parent="#accordion">
										<div className="card-body">
											<Link to="/tnpsc-coaching-centre-in-chennai">
											<div class="box-1">
												<div class="btn btn-one">
													<span>Group exams / VAO / Teaching / Police Exams & RRB</span>
												</div>
											</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
			          </div>
			        </div>
			      </div>




			    </div>
				
				
			  </div>
			</div>

        }
}

export default CourseHomepage